var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0a579b",
    width: 36.316,
    height: 36.282,
    viewBox: "0 0 36.316 36.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(-67 -750)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "currency-exchange",
    d: "M0,11.33A11.353,11.353,0,0,0,9.138,22.463a14.663,14.663,0,0,1,1.237-4.7A5.119,5.119,0,0,1,6.809,13.4H5.674v-.967H6.732v-.985c0-.1,0-.211.009-.306H5.674v-.969h1.16c.511-2.833,2.728-4.512,6.06-4.512a8.164,8.164,0,0,1,1.859.193V7.512a7.853,7.853,0,0,0-1.85-.186,3.71,3.71,0,0,0-3.936,2.842h4.351v.969H8.825c-.007.1-.007.22-.007.334v.958h4.5V13.4H8.92a3.536,3.536,0,0,0,2.281,2.79A14.753,14.753,0,0,1,22.482,9.121,11.353,11.353,0,0,0,0,11.33ZM36.316,23.814A12.484,12.484,0,1,1,23.832,11.33,12.484,12.484,0,0,1,36.316,23.814Zm-17.591,3c.157,1.9,1.693,3.371,4.458,3.545v1.4h1.226V30.35c2.858-.2,4.53-1.68,4.53-3.836,0-1.963-1.278-2.973-3.563-3.5l-.967-.227v-3.8A2.275,2.275,0,0,1,26.6,20.679h2.152c-.159-1.825-1.768-3.253-4.344-3.409v-1.4H23.183V17.3c-2.442.234-4.1,1.661-4.1,3.682,0,1.786,1.235,2.923,3.291,3.389l.813.193V28.6a2.449,2.449,0,0,1-2.277-1.786Zm4.449-4.3c-1.208-.272-1.861-.826-1.861-1.661,0-.931.706-1.632,1.87-1.836v3.5h-.011Zm1.412,2.37c1.464.329,2.14.863,2.14,1.807,0,1.076-.84,1.816-2.315,1.952v-3.8l.175.041Z",
    transform: "translate(67 749.985)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.cb223e6e7ff133b3ebe2dc7c0ad5b7dc.svg";
export { ForwardRef as ReactComponent };